module.exports = __webpack_public_path__ + "img/view-qr.ffabf74f.svg";